module.exports = __webpack_public_path__ + "static/img/Pointer.1a0f78b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/Pointer.png
// module id = rWjF
// module chunks = 1